import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartProduct,
  getUserCart,
  updateCartProduct,
} from "../features/user/userSlice";
import { symbole } from "../components/commonData";
import DataNotFound from "../components/DataNotFound";
import { AiFillDelete } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import ApiResponseModal from "../components/ApiResponseModal";

const Cart = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});
const navigate=useNavigate()
  const dispatch = useDispatch();
  const userCartState = useSelector((state) => state.auth.cartProducts);

  const customer = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  const config2 = {
    headers: {
      Authorization: `Bearer ${customer?.token || ""}`,
    },
  };

  const [productupdateDetail, setProductupdateDetail] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    dispatch(getUserCart(config2));
  }, []);

  useEffect(() => {
    if (productupdateDetail) {
      dispatch(updateCartProduct(productupdateDetail));
      setTimeout(() => dispatch(getUserCart(config2)), 200);
    }
  }, [productupdateDetail]);

  useEffect(() => {
    let sum = 0;
    userCartState?.forEach(
      (item) => (sum += item.quantity * item.price)
    );
    setTotalAmount(sum);
  }, [userCartState]);

const deleteACartProduct = async (id) => {
  try {
    await dispatch(
      deleteCartProduct({ id, config2 })
    ).unwrap();

    setApiModal({
      show: true,
      type: "success",
      title: "Removed",
      message: "Item removed from cart",
    });

    dispatch(getUserCart(config2));
  } catch (error) {
    setApiModal({
      show: true,
      type: "error",
      title: "Failed",
      message:
        error?.message || "Unable to remove item",
    });
  }
};

  const paginatedOrders = userCartState
    ? [...userCartState].reverse().slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];

  const totalPages = userCartState
    ? Math.ceil(userCartState.length / itemsPerPage)
    : 0;

  return (
    <>
        <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>
      <Meta title="Cart" />
      <BreadCrumb title="Cart" />

      {/* ===== INLINE CSS (SAME FILE) ===== */}
      <style>{`
        .cart-card {
          background: #fff;
          border-radius: 14px;
          padding: 12px;
          margin-bottom: 12px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        .cart-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
          border-radius: 8px;
          background: #f7f7f7;
        }

        .cart-title {
          font-size: 14px;
          font-weight: 600;
          line-height: 1.4;
        }

        .cart-price {
          font-weight: 700;
          color: #0d6efd;
        }

        .cart-qty input {
          width: 60px;
          text-align: center;
        }

        .cart-delete {
          cursor: pointer;
          font-size: 20px;
        }

        .cart-summary {
          background: #fff;
          border-radius: 14px;
          padding: 16px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        @media (min-width: 768px) {
          .cart-card {
            box-shadow: none;
            border-bottom: 1px solid #eee;
            border-radius: 0;
          }
        }
      `}</style>

      {paginatedOrders?.length > 0 ? (
        <Container class1="cart-wrapper home-wrapper-2 py-4">
          <div className="row">

            {/* CART ITEMS */}
            <div className="col-lg-8">

              {/* Desktop Header */}
              <div className="d-none d-md-flex cart-header fw-bold mb-3">
                <div className="col-md-5">Product</div>
                <div className="col-md-2 text-center">Price</div>
                <div className="col-md-3 text-center">Qty</div>
                <div className="col-md-2 text-end">Total</div>
              </div>

              {paginatedOrders.map((item, index) => (
                <div key={index} className="cart-card row align-items-center">
                  <div className="col-md-5 d-flex gap-3" onClick={()=>{
                     navigate("/product/" + item?._id)
                  }}>
                    <img
                      src={item?.productId?.images?.[0]?.url}
                      alt="product"
                      className="cart-img"
                        onError={(e) => {
    e.currentTarget.onerror = null;
    const fallback = item?.productId?.images?.[1]?.url ||
      "https://via.placeholder.com/600x600?text=No+Image";
    if (e.currentTarget.src !== fallback) {
      e.currentTarget.src = fallback;
    }
  }}
                    />
                    <div>
                      <div className="cart-title">
                        {item?.productId?.title}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-2 text-center">
                    <div className="cart-price">
                      {symbole} {item?.price}
                    </div>
                  </div>

                  <div className="col-md-3 d-flex justify-content-center align-items-center gap-2 cart-qty">
                    <input
                      type="number"
                      min={1}
                      max={10}
                      className="form-control"
                      value={item?.quantity}
                      onChange={(e) =>
                        setProductupdateDetail({
                          cartItemId: item?._id,
                          quantity: e.target.value,
                        })
                      }
                    />
                    <AiFillDelete
                      className="cart-delete text-danger"
                      onClick={() => deleteACartProduct(item?._id)}
                    />
                  </div>

                  <div className="col-md-2 text-end fw-bold">
                    {symbole} {item?.quantity * item?.price}
                  </div>
                </div>
              ))}

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <ul className="pagination pagination-sm">
                    {[...Array(totalPages)].map((_, i) => (
                      <li
                        key={i}
                        className={`page-item ${
                          currentPage === i + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* SUMMARY */}
            <div className="col-lg-4 mt-4 mt-lg-0">
              <div className="cart-summary">
                <h5 className="fw-bold mb-2">
                  Subtotal: {symbole} {totalAmount.toLocaleString()}
                </h5>
                <p className="text-muted mb-3">
                  Taxes & shipping calculated at checkout
                </p>
                <Link
                  to="/checkout"
                  className="btn btn-primary w-100 mb-2"
                >
                  Proceed to Checkout
                </Link>
                <Link to="/product" className="text-center d-block">
                  Continue Shopping
                </Link>
              </div>
            </div>

          </div>
        </Container>
      ) : (
        <DataNotFound />
      )}
    </>
  );
};

export default Cart;
